import styled from 'styled-components';
import { color, fontSize, fontWeight, screen, spacing } from '../../../theme';

export const StyledOfferPerksItem = styled.div`
  display: flex;
  align-items: center;

  &:not(:last-child) {
    @media (max-width: ${screen('mdMax')}) {
      padding-bottom: ${spacing('md')};
      margin-bottom: ${spacing('md')};
      border-bottom: 1px solid ${color('midnight_200')};
    }
  }
`;

export const StyledOfferPerksItemIcon = styled.div`
  display: block;
  margin-right: ${spacing('md')};
`;

export const StyledOfferPerksItemTitle = styled.h5`
  font-size: ${fontSize('xs')};
  font-weight: ${fontWeight('black')};
  text-transform: uppercase;
  line-height: 1.33;
  margin: 0;
`;

export const StyledOfferPerksItemDesc = styled.p`
  margin-top: ${spacing('xs2')};
  margin-bottom: 0;
  color: ${color('text_subtle')};
  font-size: ${fontSize('md')};
  line-height: 1.25;
`;
